import { render, staticRenderFns } from "./TingTiYanJiang.vue?vue&type=template&id=974e0ab8&scoped=true"
import script from "./TingTiYanJiang.vue?vue&type=script&lang=js"
export * from "./TingTiYanJiang.vue?vue&type=script&lang=js"
import style0 from "./TingTiYanJiang.vue?vue&type=style&index=0&id=974e0ab8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "974e0ab8",
  null
  
)

export default component.exports